import React, { memo } from 'react';
import numeral from 'numeral';
import classNames from 'classnames';

const StatsCard = memo(function StatsCard({
   title,
   isLoading,
   data = {},
   currency
}) {
    const { totalValue, prevTotalValue, relativeChange, relativeChangeString } = data;

    const formatNumber = (number) => {
        if (!currency) return number;
        if (typeof number === "undefined") return null;
        return numeral(number).format('$0.00a').toUpperCase();
    }

    return (
        <div className="flex flex-col col-span-6 xl:col-span-3 bg-white rounded-[12px] border border-[#F2F2F2] relative pt-2.5 px-2.5 pb-[13px] md:pt-[14px] md:px-4 md:pb-4">
            {!isLoading && relativeChangeString && (
                <span className={classNames(
                    'text-[11px] md:text-[12px] font-semibold leading-[1.1] text-brand-green px-[5px] py-[3.5px] rounded-full whitespace-nowrap self-start md:absolute top-2 right-2 mb-3 md:mb-0',
                    relativeChange > 0 && 'bg-[#D3F3F8]',
                    relativeChange < 0 && 'bg-[#FFE5DD]',
                    relativeChange === 0 && 'bg-[#E8E8E8]'
                )}>
                    {relativeChangeString}
                </span>
            )}
            {isLoading && <span className="animate-pulse bg-[#F2F2F2] rounded-full w-12 h-[19px] md:h-5 md:ml-2 inline-block self-start md:absolute top-2 right-2 mb-3 md:mb-0" />}
            <div className="flex flex-row justify-between mb-1.5 md:mb-2">        
                {isLoading ? (
                    <div className="animate-pulse bg-[#F2F2F2] rounded-full w-16 h-7 inline-block"></div>
                ) : (
                    <div className="text-3xl font-founders leading-[0.9] h-7 font-semibold tracking-[0.01em] text-brand-green">{formatNumber(totalValue)}</div>
                )}
            </div>
            <h3 className="text-[13px] font-semibold text-brand-green mb-0.5">
                <div className={classNames(
                    'leading-[1.1] transition ease-in',
                    isLoading && 'text-[#A5A5A5]',
                )}>
                    {title && <span>{title}</span>}
                </div>
            </h3>
        </div>
    );
}, (prevProps, nextProps) => {
    if (prevProps.isLoading !== nextProps.isLoading) {
        return false;
    }
    
    if (prevProps.title !== nextProps.title || prevProps.currency !== nextProps.currency) {
        return false;
    }
    
    if (prevProps.data.totalValue !== nextProps.data.totalValue || 
        prevProps.data.prevTotalValue !== nextProps.data.prevTotalValue ||
        prevProps.data.relativeChange !== nextProps.data.relativeChange ||
        prevProps.data.relativeChangeString !== nextProps.data.relativeChangeString) {
        return false;
    }
    
    return true;
});

export default StatsCard;
